import type { SecretSummary } from "../../api/types";
import { Button } from "../../components/Button";
import { Modal } from "../../components/Modal";
import "../../components/Form.css";

interface DeleteSecretDialogProps {
  secret: SecretSummary | null;
  isDeleting: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export function DeleteSecretDialog({ secret, isDeleting, onCancel, onConfirm }: DeleteSecretDialogProps) {
  return (
    <Modal open={secret !== null} title="Delete secret" onClose={onCancel}>
      <p>
        Delete <strong>{secret?.name}</strong>? Any workload still referencing it will fail to start until it's
        replaced with a new one. This can't be undone.
      </p>
      <div className="form-actions">
        <Button type="button" variant="secondary" onClick={onCancel} disabled={isDeleting}>
          Cancel
        </Button>
        <Button type="button" variant="danger" onClick={onConfirm} disabled={isDeleting}>
          {isDeleting ? "Deleting…" : "Delete"}
        </Button>
      </div>
    </Modal>
  );
}
